import React from "react";

export function Pill({ color, children, className = "", ...rest }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-[600] text-white whitespace-nowrap ${className}`}
      style={{ backgroundColor: color }}
      {...rest}
    >
      {children}
    </span>
  );
}
